import { ArrowDownAz, Badge, Blocks, GalleryHorizontal, Paintbrush, PartyPopper, Share } from "lucide-react";

export default function HeroCard10() {
  return (
    <>
      <section className="lms-hero">

        {/* Background opacity glow circle-10s */}
       

        {/* Doodles */}
        <PartyPopper size={60} className="doodle d1" />
        <Paintbrush size={60} className="doodle d2" />
        <Badge size={60} className="doodle d3" />

        <div className="lms-container">

          {/* LEFT SIDE CONTENT */}
          <div className="lms-left fadeUp">
            <h1 className="title">
              Learn Everyday And Any New <br />
              Skills Online With Top <br /> Instructor.
            </h1>

            <p className="subtext">
              Choose Your Favorite Course And Start Learning Today.
            </p>

            <div className="lms-btn-row">
              <button className="btn filled">Explore Courses</button>
              <button className="btn outline">Become An Instructor</button>
            </div>

            <hr className="divider" />

            {/* Stats */}
            <div className="stats">
              <div className="stat-left">
                <div className="avatars">
                  <img src="https://i.pravatar.cc/100?img=1" />
                  <img src="https://i.pravatar.cc/100?img=2" />
                  <img src="https://i.pravatar.cc/100?img=3" />
                  <img src="https://i.pravatar.cc/100?img=4" />
                  <img src="https://i.pravatar.cc/100?img=5" />
                </div>
                <span>More Than 1k+ Tutors</span>
              </div>

              <div className="stat-right">
                <div className="icon">👨‍🏫</div>
                <div className="num">239+</div>
                <span>Certified Teachers</span>
              </div>
            </div>

          </div>

          {/* RIGHT SIDE IMAGES */}
          <div className="lms-right">

            {/* Mini analytics card float-c12ing */}
            <div className="analytics-card float-c12Slow-c12 ">
              <img src="https://i.postimg.cc/g2v3W5z5/red-haired-lady-eyeglasses-holds-books-shows-ok-sign.jpg" />
            </div>

            {/* images group */}
            <div className="img circle-10 float-c12 ">
              <img src="https://i.postimg.cc/G24xxVq7/smiling-pensive-brunette-schoolgirl-with-long-hair-hugging-book.jpg" />
            </div>

            <div className="img tile-10 float-c12Delay ">
              <img src="https://i.postimg.cc/fb0Gq22L/cheerful-student-posing-against-pink-wall-with-glasses.jpg" />
            </div>

            <div className="circle-102 float-c12Slow-c12 ">
            <Share size={160} className="doodle d1" />
       </div>

            <div className=" square-c10 float-c12Delay ">
            <Blocks size={60} className="doodle d1" />
        </div>

          </div>

        </div>
      </section>

      <style>{`
/* ------------------------------------------- */
/* HERO BASE */
/* ------------------------------------------- */
.lms-hero {
  background: #eef5ff;
  padding: 120px 0 140px;
  position: relative;
  overflow: hidden;
  font-family: Inter, sans-serif;
}

/* Notebook lined background */
.lms-hero::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: linear-gradient(
    to bottom,
    transparent 95%,
    rgba(0,0,0,0.06) 96%
  );
  background-size: 100% 40px;
  opacity: .25;
  pointer-events: none;
}

/* ------------------------------------------- */
/* CONTAINER */
/* ------------------------------------------- */
.lms-container {
  max-width: 1300px;
  margin: auto;
  width: 90%;
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 40px;
}

/* ------------------------------------------- */
/* LEFT CONTENT */
/* ------------------------------------------- */
.title {
  font-size: 48px;
  font-weight: 800;
  margin-bottom: 20px;
  color: #222;
}

.subtext {
  color: #555;
  font-size: 18px;
  margin-bottom: 30px;
}

.btn {
  padding: 14px 34px;
  font-size: 16px;
  border-radius: 10px;
  cursor: pointer;
  font-weight: 600;
  transition: .3s;
}
.filled {
  background: #156bff;
  border: none;
  color: #fff;
}
.filled:hover { background:#2e7aff; transform:translateY(-4px); }
.outline {
  background: transparent;
  border: 2px solid #156bff;
  color: #156bff;
}
.outline:hover { background:#156bff; color:#fff; transform:translateY(-4px); }

.lms-btn-row {
  display: flex;
  gap: 20px;
}

.divider {
  margin: 40px 0 30px;
  border: none;
  border-top: 2px solid #ccc;
  opacity: .4;
}

/* STATS */
.stats {
  display: flex;
  align-items: center;
  gap: 40px;
}

.stat-left span,
.stat-right span {
  font-size: 15px;
  color: #444;
}

.avatars img {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 2px solid #fff;
  margin-left: -10px;
}

/* Certified teachers */
.stat-right {
  display: flex;
  align-items: center;
  gap: 10px;
}
.stat-right .num {
  font-size: 30px;
  font-weight: 700;
  color: #156bff;
}

/* ------------------------------------------- */
/* RIGHT IMAGE AREA */
/* ------------------------------------------- */
.lms-right {
  position: relative;
  display: grid;
  grid-template-columns: repeat(2,1fr);
  gap: 35px;
}

.img {
  overflow: hidden;
  position: relative;
  border-radius: 30px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.15);
}
.img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Circle images */
.circle-10 {
  width: 210px;
  height: 210px;
  border-radius: 50%;
}
.circle-10 img { border-radius: 50%; }

/* Second circle-10 variant */
.circle-102 {
  width: 180px;
  height: 180px;
  border-radius: 50%;
}
.circle-102 img { border-radius: 50%; }

/* Rounded tile-10 */
.tile-10 {
  border-radius: 40px;
}

/* Square */
.square-c10 {
  border-radius: 20px; position: absolute;
  right: 6%;
  top: 30%;
}

/* ------------------------------------------- */
/* ANALYTICS FLOAT CARD */
/* ------------------------------------------- */
.analytics-card {
  position: absolute;
  right: -60px;
  top: -30px;
  width: 180px;
  transform: rotate(8deg);
  z-index: 10;
}
.analytics-card img {
  width: 100%;
  border-radius: 18px;
  box-shadow: 0 10px 30px rgba(0,0,0,.2);
}

/* ------------------------------------------- */
/* GRADIENT SHINE SWEEP */
/* ------------------------------------------- */
.shine-c12::before {
  content:"";
  position:absolute;
  top:-100%;
  left:-150%;
  width:300%;
  height:300%;
  background:linear-gradient(
    120deg,
    transparent 0%,
    rgba(255,255,255,0.4) 45%,
    rgba(255,255,255,0.75) 50%,
    rgba(255,255,255,0.4) 55%,
    transparent 100%
  );
  transform:translateX(-100%);
  transition:transform 0.75s ease-out;
}
.shine-c12:hover::before {
  transform:translateX(100%);
}

/* ------------------------------------------- */
/* OPACITY GLOW CIRCLES */
/* ------------------------------------------- */
.ocircle-10 {
  position:absolute;
  border-radius:50%;
  background:radial-gradient(circle-10,
    rgba(255,255,255,0.20),
    rgba(255,255,255,0.05),
    transparent
  );
  filter:blur(4px);
  pointer-events:none;
}
.oc1 { width:320px;height:320px; left:10%; top:15%; opacity:.3; }
.oc2 { width:220px;height:220px; right:20%; top:30%; opacity:.25; }
.oc3 {
  width:260px;height:260px; left:60%; bottom:5%;
  opacity:.25;
  animation: ocPulse 5s infinite ease-in-out;
}

@keyframes ocPulse {
  0% { transform:scale(1); opacity:.2;}
  50%{ transform:scale(1.15); opacity:.45;}
  100%{ transform:scale(1); opacity:.2;}
}

/* ------------------------------------------- */
/* FLOAT ANIMATIONS */
/* ------------------------------------------- */
.float-c12 { animation: ffloat-c12 4s ease-in-out infinite; }
.float-c12Slow-c12 { animation: ffloat-c12 6s ease-in-out infinite; }
.float-c12Delay { animation: ffloat-c12 4.6s ease-in-out infinite; }
.float-c12Delay2 { animation: ffloat-c12 5.2s ease-in-out infinite; }

@keyframes ffloat-c12 {
  0%{ transform:translateY(0px); }
  50%{ transform:translateY(-12px); }
  100%{ transform:translateY(0px); }
}

/* FADE UP */
.fadeUp {
  opacity:0;
  animation: fadeUpA .9s ease forwards;
}
@keyframes fadeUpA {
  from{ opacity:0; transform:translateY(20px);}
  to{ opacity:1; transform:translateY(0);}
}

/* ------------------------------------------- */
/* DOODLES */
/* ------------------------------------------- */
.doodle {
  position:absolute;
  opacity:.15;
  width:110px;
}
.d1 { top:60%; left:20%; transform:rotate(10deg); opacity:.12;}
.d2 { top:35%; left:43%; width:140px; opacity:.12; }
.d3 { top:12%; left:30%; opacity:.10; }

/* ------------------------------------------- */
/* RESPONSIVE */
/* ------------------------------------------- */
@media(max-width:900px){
  .lms-container{
    grid-template-columns:1fr;
  }
  .lms-right{
    margin-top:50px;
  }
}

      `}</style>
    </>
  );
}
